import {TypedUseSelectorHook, useSelector} from "react-redux";
import {RootState} from "migration/app/store";

export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
